// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"a9065414","197":"d1eb7282","431":"8f0b0c02","662":"921b4261","757":"0ed2edf7","864":"dbceb339"}[chunkId] + ".chunk.js";
};